@if (authService.hasPermission(Permission.BatchesFull)) {
  <h3 class="title-chart">Jobs Overview</h3>
  <div class="chart">
    <div class="bar-chart" (window:resize)="onResize($event)" #chartCtn id="chartCtn">
      <canvas id="myBarChart"></canvas>
    </div>
  </div>
}
